module.exports = __webpack_public_path__ + "img/questionMark.f1fcd2f9.svg";